<template>
  <div>
    <PCNavbar selectIndex="2-1"/>
    <MobileNavBar :currentActive="1" />
    <router-view></router-view>
    <DemoForm/>
    <CallMe/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import DemoForm from '@/components/demo'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    DemoForm
  },
  metaInfo: {
    title: '产品服务',
    meta: [
      { 
        vmid: 'description', 
        name: 'description', 
        content: '柳叶云提供全面的医疗器械管理软件服务，包括进销存管理、ERP系统、WMS仓库管理、手术管理、订单管理等功能，实现医疗器械全生命周期的数字化管理。' 
      },
      { 
        vmid: 'keywords', 
        name: 'keywords', 
        content: '医疗器械ERP,WMS仓库管理,进销存管理,手术管理,订单管理,医疗器械经销商管理' 
      }
    ]
  }
}
</script>

<style>
</style>